/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSessionAndMessagesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_service.pb'
import {GetSessionAndMessagesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_service.pb'


export const getSessionAndMessages = (request: GetSessionAndMessagesRequest, options?: CashRequestOptions) => post<GetSessionAndMessagesRequest, GetSessionAndMessagesResponse>("/2.0/cash/get-session-and-messages", request, {...options, rejectOnError: true })